package diana.soleil.design.iraniancanadienbazzar.core.data

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Base URL used in share links (`{base}/b/{businessId}`, `{base}/item/{itemId}`,
 * `{base}/post/{postId}`, `{base}/event/{eventId}` — served by Hosting). Driven by Remote
 * Config `share_base_url` from the composition root so dev shares point at the dev site until
 * mahaleh.ca is connected to prod Hosting.
 */
class ShareConfig {
    private val _baseUrl = MutableStateFlow("https://mahaleh.ca")
    val baseUrl: StateFlow<String> = _baseUrl.asStateFlow()

    fun setBaseUrl(url: String) {
        if (url.isNotBlank()) _baseUrl.value = url.trimEnd('/')
    }

    fun businessLink(businessId: String): String = "${_baseUrl.value}/b/$businessId"

    fun itemLink(itemId: String): String = "${_baseUrl.value}/item/$itemId"

    fun postLink(postId: String): String = "${_baseUrl.value}/post/$postId"

    /** Invite / "get the app" link — the home landing page (App Links open the app when installed). */
    fun inviteLink(): String = _baseUrl.value

    fun eventLink(eventId: String): String = "${_baseUrl.value}/event/$eventId"

    /** Hidden Gems share deep links (`docs/HIDDEN_GEMS_PLAN.md` §6 — web landing renders these). */
    fun jokeLink(jokeId: String): String = "${_baseUrl.value}/gems/joke/$jokeId"

    fun recipeLink(recipeId: String): String = "${_baseUrl.value}/gems/recipe/$recipeId"

    fun factLink(factId: String): String = "${_baseUrl.value}/gems/danestaniha/$factId"

    fun taleLink(taleId: String): String = "${_baseUrl.value}/gems/shahnameh/$taleId"

    fun poemLink(poemId: String): String = "${_baseUrl.value}/gems/poem/$poemId"

    fun storyLink(storyId: String): String = "${_baseUrl.value}/gems/story/$storyId"
}
